"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TabContext = require("../../TabContext");
const TabPanels = ({
  children,
  dataTest
}) => {
  const {
    selected
  } = (0, _TabContext.useTabs)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full",
    "data-test": dataTest
  }, _react.default.Children.map(children, (child, idx) => {
    if (! /*#__PURE__*/_react.default.isValidElement(child)) return null;
    return /*#__PURE__*/_react.default.createElement(_TabContext.TabPanelProvider, {
      isActive: selected === idx,
      index: idx
    }, child);
  }));
};
var _default = exports.default = TabPanels;